function isMobile(value: string) {
  return /^1[3-9][0-9]\d{8}$/.test(value);
}

export default isMobile;
